module.exports = __webpack_public_path__ + "static/media/mobile_game_game_virtualRoulette_en.9e4a4454.png";